var map = {
	"./": [
		308,
		9
	],
	"./ExternalGameById": [
		1100,
		9,
		94
	],
	"./ExternalGameById.dictionary": [
		331,
		3
	],
	"./ExternalGameById.dictionary.json": [
		331,
		3
	],
	"./ExternalGameById.explanation": [
		1102,
		9,
		95
	],
	"./ExternalGameById.explanation.ts": [
		1102,
		9,
		95
	],
	"./ExternalGameById.module.scss": [
		1101,
		9,
		251
	],
	"./ExternalGameById.tsx": [
		1100,
		9,
		94
	],
	"./ExternalGameByIdDeferred": [
		346,
		9
	],
	"./ExternalGameByIdDeferred.tsx": [
		346,
		9
	],
	"./components/IframeErrorAlert": [
		951,
		9,
		53
	],
	"./components/IframeErrorAlert/": [
		951,
		9,
		53
	],
	"./components/IframeErrorAlert/IframeErrorAlert.dictionary": [
		1013,
		3,
		177
	],
	"./components/IframeErrorAlert/IframeErrorAlert.dictionary.json": [
		1013,
		3,
		177
	],
	"./components/IframeErrorAlert/IframeErrorAlert.module.scss": [
		1055,
		9,
		286
	],
	"./components/IframeErrorAlert/index": [
		951,
		9,
		53
	],
	"./components/IframeErrorAlert/index.tsx": [
		951,
		9,
		53
	],
	"./index": [
		308,
		9
	],
	"./index.tsx": [
		308,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1231;
module.exports = webpackAsyncContext;